import { Configuration, PopupRequest } from "@azure/msal-browser";

// Config object to be passed to Msal on creation
export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_SSO_CLIENT_ID!,
    authority: process.env.REACT_APP_SSO_AUTHORITY,
    redirectUri: process.env.REACT_APP_HOMEPAGE_URL,
    postLogoutRedirectUri: process.env.REACT_APP_HOMEPAGE_URL,
  },
  system: {
    allowNativeBroker: false, // Disables WAM Broker
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest: PopupRequest = {
  scopes: [process.env.REACT_APP_SSO_READ_SCOPE!],
};

// Add here the endpoints for MS Graph API services you would like to use.
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
  graphCreateUserEndpoint: "https://graph.microsoft.com/v1.0/users",
};
